import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import AdminLayout from "@/layouts/AdminLayout";
import ProtectedRoute from "@/routes/ProtectedRoute";
import Login from "@/pages/Login";
import NewsletterSubscribers from "@/pages/NewsletterSubscribers";
import Campaigns from "@/pages/Campaigns";
import HeroSliders from "@/pages/HeroSliders";
import Messages from "@/pages/Messages";
import Branches from "@/pages/Branches";
import AboutPage from "@/pages/AboutPage";
import Categories from "@/pages/Categories";
import Policies from "@/pages/Policies";
import SeoSettings from "@/pages/SeoSettings";
import Guests from "@/pages/Guests";
import MailSend from "@/pages/MailSend";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route
          element={
            <ProtectedRoute>
              <AdminLayout />
            </ProtectedRoute>
          }
        >
          <Route path="/" element={<Navigate to="/newsletter" replace />} />
          <Route path="/newsletter" element={<NewsletterSubscribers />} />
          <Route path="/newsletter/campaign/:id" element={<NewsletterSubscribers />} />
          <Route path="/campaigns" element={<Campaigns />} />
          <Route path="/hero" element={<HeroSliders />} />
          <Route path="/messages" element={<Messages />} />
          <Route path="/branches" element={<Branches />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/categories" element={<Categories />} />
          <Route path="/policies" element={<Policies />} />
          <Route path="/seo" element={<SeoSettings />} />
          <Route path="/guests" element={<Guests />} />
          <Route path="/mail-send" element={<MailSend />} />
        </Route>
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
      <Toaster position="top-right" richColors />
    </BrowserRouter>
  );
}


export default App;
